import * as React from "react";
import { cn } from "@repo/common/utils/cn";

export type InputProps = React.ComponentProps<"input"> & {
  passwordrules?: string;
  autocomplete?: string;
  sizeVariant?: "md" | "lg";
};

function Input({ className, type, sizeVariant = "md", ...props }: InputProps) {
  return (
    <input
      data-slot="input"
      type={type}
      className={cn(
        "flex w-full rounded-sm border border-border bg-background p-2 text-base md:text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium text-foreground placeholder:text-foreground/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary-hover focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-background-muted disabled:placeholder-shown:bg-background disabled:placeholder-shown:opacity-50",
        sizeVariant === "lg" ? "h-12" : "h-8",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
